<template>

  <v-container>
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title class="headline">{{ prueba.nombrePrueba }}</v-list-item-title>
        <v-list-item-subtitle>Creado por {{ usuario.username }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

     <v-divider></v-divider>

    <v-list class="transparent">
      <v-list-item>
        <v-list-item-title class="text-left">Ensayos</v-list-item-title>
        <v-list-item-subtitle class="text-right">{{ prueba.ensayos_count }}</v-list-item-subtitle>
      </v-list-item>
      <v-list-item>
        <v-list-item-title class="text-left">Datos</v-list-item-title>
        <v-list-item-subtitle class="text-right">{{ prueba.series_count }}</v-list-item-subtitle>
      </v-list-item>
      <v-list-item>
        <v-list-item-title class="text-left">Fecha de creación</v-list-item-title>
        <v-list-item-subtitle class="text-right">{{ toNormalDate(prueba.timestamp) }}</v-list-item-subtitle>
      </v-list-item>
    </v-list>

    <v-divider></v-divider>

    <v-row align="center" justify="center">
      <v-col class="text-center">

        <v-simple-table>

          <template v-slot:top>

            <v-toolbar flat color="white">
              <v-toolbar-title>Configuración General</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>

          </template>

          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Nombre</th>
                <th class="text-left">Valor</th>
                <th class="text-left">Acciones</th>

              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Sala de Entrenamiento</td>
                <td><v-checkbox :disabled="![1,2].some(r => usuario.groups.includes(r))" label="Activar" v-model="trainingEnabled" value="true" @click="editPrueba()"></v-checkbox></td>
                <td></td>
              </tr>
              <tr>
                <td>Control Análogo</td>
                <td><v-checkbox :disabled="![1,2].some(r => usuario.groups.includes(r))" label="Activar" v-model="analogEnabled" value="true" @click="editPrueba()"></v-checkbox></td>
                <td></td>
              </tr>
              <tr>
                <td>Posición neutra control Eje X</td>
                <td>
                  <!--<v-text-field label="Editar" v-model="joystickCenterX" value="true" @click="editPrueba()"></v-text-field>-->
                  <span v-if="joystickCenterX.isEditing===false">{{joystickCenterX.value}}</span>
                  <v-text-field v-else class="pa-0 centered-input" v-model="joystickCenterX.value" hide-details single-line></v-text-field>
                </td>
                <td>
                  <v-icon :disabled="![1,2].some(r => usuario.groups.includes(r))" v-if="joystickCenterX.isEditing===false" small class="mr-2" @click="editPruebaText(joystickCenterX)">mdi-pencil</v-icon>
                  <v-container v-else>
                    <v-icon small class="mr-2" @click="savePruebaText(joystickCenterX)">mdi-check</v-icon>
                    <v-icon small class="mr-2" @click="cancelEditPruebaText(joystickCenterX)">mdi-close</v-icon>
                  </v-container>
                </td>
              </tr>
              <tr>
                <td>Posición neutra control Eje Y</td>
                <td>
                  <!--<v-text-field label="Editar" v-model="joystickCenterX" value="true" @click="editPrueba()"></v-text-field>-->
                  <span v-if="joystickCenterY.isEditing===false">{{joystickCenterY.value}}</span>
                  <v-text-field v-else class="pa-0 centered-input" v-model="joystickCenterY.value" hide-details single-line></v-text-field>
                </td>
                <td>
                  <v-icon :disabled="![1,2].some(r => usuario.groups.includes(r))" v-if="joystickCenterY.isEditing===false" small class="mr-2" @click="editPruebaText(joystickCenterY)">mdi-pencil</v-icon>
                  <v-container v-else>
                    <v-icon small class="mr-2" @click="savePruebaText(joystickCenterY)">mdi-check</v-icon>
                    <v-icon small class="mr-2" @click="cancelEditPruebaText(joystickCenterY)">mdi-close</v-icon>
                  </v-container>
                </td>
              </tr>
              
            </tbody>
          </template>
        </v-simple-table>

      </v-col>
    </v-row>

  </v-container>
</template>


<script>

  import moment from 'moment';

  export default {
    computed: {
      prueba() {
        console.log('SE DEFINE PRUEBA')
        return this.$store.state.prueba
      },
      usuario() {
        return this.$store.state.user;
      },
    },
    created() {
      console.log('SE EJECUTA CREATED')
      
    },
    mounted() {
      console.log('SE EJECUTA MOUNTED')
    },
    updated() {
      console.log('SE EJECUTA UPDATED')
      this.initialize()
    },
    data: () => ({
      trainingEnabled: [],
      analogEnabled: [],
      joystickCenterX: {
        isEditing: false,
        value: null,
        preValue: null,
      },
      joystickCenterY: {
        isEditing: false,
        value: null,
        preValue: null,
      },
      pruebaData: null,
    }),

    methods: {
      initialize() {
        if (this.prueba.trainingEnabled){
          this.trainingEnabled.push("true")
        }

        if (this.prueba.analogEnabled){
          this.analogEnabled.push("true")
        }
        this.joystickCenterX.value = this.prueba.joystickCenterX;
        this.joystickCenterY.value = this.prueba.joystickCenterY;
      },
      editPrueba() {
        //Se checkea uno por uno los valores de la configuracion y se envian para actualizarlo
        if (this.trainingEnabled.length > 0){
          console.log('TRAINING ACTIVADO')
          this.prueba.trainingEnabled = true
        }
        else{
          console.log('TRAINING DESACTIVADO')
          this.prueba.trainingEnabled = false
        }

        if (this.analogEnabled.length > 0){
          console.log('ANALOG ACTIVADO')
          this.prueba.analogEnabled = true
        }
        else{
          console.log('ANALOG DESACTIVADO')
          this.prueba.analogEnabled = false
        }

        this.$store.dispatch('savePruebaConfig', {
          'item': this.prueba,
        });

      },
      editPruebaText(item) {
        item.isEditing = true;
        item.preValue = item.value;

      },
      savePruebaText(item) {
        //Por simplicidad, almacenamos todas las variables de texto posibles
        this.prueba.joystickCenterX = this.joystickCenterX.value;
        this.prueba.joystickCenterY = this.joystickCenterY.value;

        this.$store.dispatch('savePruebaConfig', {
          'item': this.prueba,
        });

        item.isEditing = false;

      },
      cancelEditPruebaText(item){
        item.isEditing = false;
        item.value = item.preValue;
      },

      toNormalDate(timestamp) {
        return moment(timestamp).format("DD/MM/YYYY");
      },

    },
  }
</script>